module.exports = __webpack_public_path__ + "img/CAPTURE_TAUR_377.3cf6c9fa.jpg";